'use client';

import dayjs from 'dayjs';
import { Fragment, useMemo } from 'react';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { useParams, useSearchParams } from 'next/navigation';

import { useClientTranslation } from '@/hook/translate';
import { dealLng } from '@/utils';
import Link from 'next/link';
import { TCate } from '@/types/component';

dayjs.extend(customParseFormat);

interface IProps {
  topic: TCate[];
  category: TCate;
  update: string;
}

export default function MdHeader(props: IProps) {
  const { t } = useClientTranslation();
  const searchParams = useSearchParams();
  const params = useParams();

  const breadName = useMemo(() => {
    const from = searchParams.get('from');
    if (from) {
      return from === 'collection' ? 'collection' : 'magazine';
    } else {
      return 'home';
    }
  }, [searchParams]);




  return (
    <header className='pt-5'>
      <div className='text-[rgba(25,19,0,0.5)] text-14-19' key={'updateTime'}> 
        { t('updateTime', 'mindfulAudio') } 
        <span className='pl-1'>{ dayjs(props.update).format('YYYY/MM/DD') }</span>
      </div>
      <div className='text-16-22 pt-3' key={'Bread'}>
        <span>{ t(breadName as any) }</span>
        <span className='px-1'>&gt;</span>
        <Link href={`${dealLng(params.lng as string)}/home/${props?.category?.link}/all/1`}>
        <span>{ props.category ?  props.category.name : '' }</span>
        </Link>
      </div>
      <div className='text-16-22 pt-3' key={'topic'}>
        <span className='pr-3'>{ t('topic') }:</span>
        {
          props.topic.map((top, index, arr) => {
            return (
              <Fragment key={top.name}>
               <Link href={`${dealLng(params.lng as string)}/home/${ top.link }/1`}>
               <span className='underline' key={top.name}>{ top.name }</span>
               </Link>
                { index === arr.length - 1 ? '' : <span className='px-1' key={'split'}>,</span> }
              </Fragment>
            );
          })
        }
      </div>
    </header>
  );
}
